
import {get,post,put} from '@/utils/request'
import {proxyHeader} from "@/utils/config"

//获取卫星分类以及分类中的个数
export const getSatelliteClass = p => get(proxyHeader+'service/satellite-service/satellite/getTypeList', p);

//根据卫星分类获取该类卫星的传感器与产品类型
export const getSensorByClassId = p => get(proxyHeader+'service/satellite-service/satellite/getSensorAndProductType', p);

//根据卫星分类，传感器，产品类型 分页获取卫星产品列表
export const getSatelliteList = p => get(proxyHeader+'service/satellite-service/product/queryList', p);

//添加文件到购物车
export const addToCar = p => post(proxyHeader+'service/order-service/car/addCarForSatellite',p);

//获取卫星详情
export const getSatelliteInfo = p => get(proxyHeader+'service/satellite-service/product/findById',p);

//从es查询卫片数据
export const getSatelliteListForEs = p => post(proxyHeader+'service/satellite-service/product-file/listForEs',p);

//新增卫星申请
export const satelliteApplyFor = p => post(proxyHeader+'service/satellite-service/satellite-apply-for/save',p);

//修改卫星申请
export const satelliteApplyForUpdate = p => post(proxyHeader+'service/satellite-service/satellite-apply-for/update',p);

//卫星申请列表
export const satelliteApplyForList = p => get(proxyHeader+'service/satellite-service/satellite-apply-for/list',p);

//根据多个id删除我的卫星申请数据
export const satelliteApplyForDelete = p => post(proxyHeader+'service/satellite-service/satellite-apply-for/delete',p);

//卫星数据审核列表
export const approvalList = p => get(proxyHeader+'service/satellite-service/satellite-apply-for/approvalList',p);

//卫星数据审核列表
export const approval = p => put(proxyHeader+'service/satellite-service/satellite-apply-for/approval',p);

//卫星数据审核列表
export const allAddShopcar = p => post(proxyHeader+'service/order-service/car/addCarForAllSatellite',p);

//卫星数据拷贝分发
export const getCopyRcord = p => get(proxyHeader+'service/satellite-service/satellite-copy-record/list',p);

//卫星分发产品分类
export const getBySatelliteType = p => get(proxyHeader+'service/satellite-service/product/getBySatelliteType',p);

//卫星分发新增
export const addCopyRcored = p => post(proxyHeader+'service/satellite-service/satellite-copy-record/save',p);

//卫星分发删除
export const deleteCopyRcored = p => post(proxyHeader+'service/satellite-service/satellite-copy-record/delete',p);

//全数据覆盖范围
export const getHasDataByProductId = p => get(proxyHeader+'service/satellite-service/orbital-plane-geo-object/getHasDataByProductId',p);
